import StartQuiz from "./startQuiz/StartQuiz"
import Questions from "./answer/Questions"
import EndQuiz from './endQuiz/EndQuiz'
import { useState } from 'react'
import { get_question, get_question_answers } from "../../../server/requests"
import { useEffect } from "react"

import { crypt,decrypt } from "../../Util/util"

const Quiz = ({ configs, callbackSetShowQuiz }) => {

    const [startQuiz, setStartQuiz] = useState('start')
    const [questionData, setQuestionData] = useState([])
    const [questionNumber, setQuestionNumber] = useState(0)
    const [getElmId, setElmId] = useState(null)
    const [allIndex, setAllIndex] = useState([])
    const [isAnswerChecked, setIsAnswerCheked] = useState(false)
    const [levelUser, setLevelUser] = useState(0)

    useEffect(() => {

        get_question({}, data => {

            if (data.question.length) setQuestionData(data.question)

            else callbackSetShowQuiz(true)

        }, () => callbackSetShowQuiz(true))

    }, [])


    const changeComponent = (e, level) => {

        if (level) changeUserData(level)

        setStartQuiz(e)

    }
    const spikAllQuestion = () => {

        let body = { answers: JSON.stringify([]) }

        get_question_answers(body, res => {

            changeUserData(0)
            callbackSetShowQuiz(true)

        }, err => console.log(err))

    }

    const changeUserData = (level) => {

        let user = JSON.parse(decrypt('user', localStorage.getItem('user')))

        user.level = level
        user.is_quiz_passed = true

        localStorage.setItem('user', crypt('user', JSON.stringify(user)))

        setLevelUser(level)

    }

    return (
        <>
            {
                startQuiz == 'start' ? (

                    <StartQuiz
                        configs={configs}
                        spikAllQuestion={spikAllQuestion}
                        changeComponent={changeComponent}
                    />

                ) : startQuiz === 'quiz' ? (

                    <Questions
                        configs={configs}
                        changeComponent={changeComponent}
                        questionData={questionData}
                        questionNumber={questionNumber}
                        setQuestionNumber={setQuestionNumber}

                        getElmId={getElmId}
                        setElmId={setElmId}

                        allIndex={allIndex}
                        setAllIndex={setAllIndex}

                        isAnswerChecked={isAnswerChecked}
                        setIsAnswerCheked={setIsAnswerCheked}
                    />

                ) : (
                    <EndQuiz
                        configs={configs}
                        callbackSetShowQuiz={callbackSetShowQuiz}
                        levelUser={levelUser}
                    />
                )

            }

        </>
    )
}

export default Quiz